import { createBrowserHistory } from 'history';

// In order to reference history object outside of a React class, we create the history object manually.
// https://github.com/ReactTraining/history
const history = createBrowserHistory();
export default history;
